import React from 'react';

export const Section = ({ num, title, text }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-6">
      <span className="text-[10px] font-mono font-black text-zinc-400 dark:text-zinc-600 tracking-tighter italic">
        CODE_{num}
      </span>
      <div className="h-[1px] flex-grow bg-zinc-100 dark:bg-zinc-900"></div>
    </div>
    <div className="md:pl-20 space-y-3">
      <h3 className="text-xs font-black uppercase tracking-[0.4em] text-thriftBlack dark:text-thriftSilver">
        {title}
      </h3>
      <p className="text-sm md:text-base text-zinc-600 dark:text-zinc-400 leading-relaxed font-medium max-w-3xl">
        {text}
      </p>
    </div>
  </div>
);

export const LegalPage = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-white dark:bg-black pt-40 pb-24 px-6 transition-colors duration-500">
    <div className="max-w-5xl mx-auto">
      <header className="mb-24 border-b border-zinc-100 dark:border-zinc-900 pb-12">
        <h1 className="text-6xl md:text-8xl font-black italic tracking-tighter uppercase dark:text-white leading-[0.8] mb-6">
          {title}<span className="text-zinc-200 dark:text-zinc-800">.</span>
        </h1>
        <p className="text-[10px] font-black uppercase tracking-[0.6em] text-thriftGrey italic">
          {subtitle} // ESTABLISHED 2026 // GLOBAL ARCHIVE
        </p>
      </header>
      <div className="space-y-20">
        {children}
      </div>
    </div>
  </div>
);